export default "__VITE_ASSET__D$tMF63i__"